import React, {useState} from "react";
import axios from 'axios';
import {useTranslation} from "react-i18next";

export default function ConnectboxElement(props) {


    const [isDisabled, setIsDisabled] = useState(false); // State to track button disable
    const { t } = useTranslation();

    const sendMessage = (e) => {
        e.preventDefault();
        console.log("send a message");
        setIsDisabled(true);
        const delay = props.item.data['delay'] | 0;
        if (delay > 0) {
            setTimeout(() => setIsDisabled(false), delay * 1000);
        }

        const formData = new FormData();
        formData.append("method", "new");
        formData.append("connectbox", props.item.data['connectbox'])

        const apiClient = axios.create({
            baseURL: process.env.CLIENT_API_URL,
            withCredentials: true,
            withXSRFToken: true,
        });


        apiClient.get(process.env.CLIENT_API_URL + '/sanctum/csrf-cookie')
            .then(response => {
                apiClient.post(process.env.CLIENT_API_URL + "/client/connectbox", formData)
                    .then((response) => {
                        console.log(response.data)
                    })
            })
    }

    return (
        <div className="text-center">
            {props.item.data.connectbox &&
                <button onClick={sendMessage} disabled={isDisabled} className={`bg-[#EE7203] text-white font-bold py-3 px-14 rounded-xl ${isDisabled ? 'opacity-40' : 'opacity-100'}`}>{t('button.turn_on')}</button>
            }
        </div>
    );
}